export default __webpack_public_path__ + "static/media/vipbet.87de97c2.png";